const getRoles = (token) => {
    const value = token['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
    return Array.isArray(value) ? value : [value]
}

export default {
    name: 'token-utils',
    props: {
        token: { type: Object, required: true }
    },
    computed: {
        roles({ token }) {
            return getRoles(token)
        }
    },
    methods: {
        inRole(rolename) {
            const { token } = this
            return getRoles(token).indexOf(rolename) >= 0
        },
        notInRole(rolename) {
            const { token } = this
            return getRoles(token).indexOf(rolename) < 0
        }
    }
}